import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_LOCATION_TYPE,
  UPDATE_LOCATION_TYPE_IMAGE_DETAILS,
  UPDATE_LOCATION_TYPE_SIMPLE_DETAILS,
} from '../action-types'
import { LOCATION_TYPE_INITIAL_STATE } from '../initial-states'

const locationTypeReducer = (state = LOCATION_TYPE_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LOCATION_TYPE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_LOCATION_TYPE.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.locationType,
        }),
      )

    case FETCH_LOCATION_TYPE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_LOCATION_TYPE.CLEANUP:
      return { ...LOCATION_TYPE_INITIAL_STATE }

    case UPDATE_LOCATION_TYPE_SIMPLE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: true,
          simpleDetailsError: undefined,
        }),
      )

    case UPDATE_LOCATION_TYPE_SIMPLE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateLocationTypeSimpleDetails,
          ),
        }),
      )

    case UPDATE_LOCATION_TYPE_SIMPLE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: action.error.message,
        }),
      )

    case UPDATE_LOCATION_TYPE_IMAGE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_LOCATION_TYPE_IMAGE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateLocationTypeImageDetails,
          ),
        }),
      )

    case UPDATE_LOCATION_TYPE_IMAGE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: action.error.message,
        }),
      )
    default:
      return state
  }
}

export default locationTypeReducer
